import {
  MDSButton,
  MDSButtonGroup,
  MDSButtonVariant,
  MDSDialogSlotName,
  MDSDialogTextContent,
  MDSModalZIndex,
  MDSModalDialog,
} from "@/mds";
import { MDSText, MDSTextVariant } from "@/mds";
import { APP_CONFIG } from "@/domains/global/config";
import { TrackedEvent, trackEvent } from "@/domains/metrics";
import { useEffectOnMount } from "@/domains/react/useEffectOnMount";
import { windowModule } from "@/modules/window";
import { useAppStore } from "@/store";
import { noop } from "lodash-es";
import { observer } from "mobx-react-lite";
import { useEffect, useMemo, useState } from "react";

export const SyncStoreInitializationChecker = observer(function SyncStoreInitializationChecker() {
  const { store } = useAppStore();

  const [isOpen, setIsOpen] = useState(store.sync.initializationFailed);

  const [channel, setChannel] = useState<BroadcastChannel>();

  useEffectOnMount(() => {
    const channel = new BroadcastChannel("initialization-failed");
    setChannel(channel);

    channel.onmessage = event => {
      const isFailed = event.data;
      if (isFailed) setIsOpen(true);
    };
  });

  useEffect(() => {
    if (!store.sync.initializationFailed) return;

    setIsOpen(true);
    channel?.postMessage(true);
    trackEvent(TrackedEvent.AppStoreInitErrorShown);
  }, [channel, store.sync.initializationFailed]);

  const title = useMemo(() => {
    if (store.sync.initializationFailure?.title) {
      return store.sync.initializationFailure.title;
    }

    return "Something went wrong";
  }, [store.sync.initializationFailure?.title]);

  const message = useMemo(() => {
    if (store.sync.initializationFailure?.message) {
      return store.sync.initializationFailure.message;
    }

    return "Please reload to continue. If this persists, please contact support.";
  }, [store.sync.initializationFailure?.message]);

  return (
    <MDSModalDialog
      isDismissable={false}
      isOpen={isOpen}
      handleClose={noop}
      zIndex={MDSModalZIndex.AppStoreCrashNotice}
    >
      <MDSText slot={MDSDialogSlotName.Header} variant={MDSTextVariant.HeaderL}>
        {title}
      </MDSText>
      <MDSDialogTextContent slot={MDSDialogSlotName.Content}>
        <MDSText variant={MDSTextVariant.ParagraphS}>{message}</MDSText>
      </MDSDialogTextContent>

      <MDSButtonGroup slot={MDSDialogSlotName.ButtonsRight}>
        <MDSButton
          variant={MDSButtonVariant.Default}
          onClick={() =>
            windowModule.openInNewTab({ url: new URL(APP_CONFIG.URLS.HELP_AND_SUPPORT) })
          }
        >
          Support
        </MDSButton>
        <MDSButton variant={MDSButtonVariant.Contrast} onClick={() => windowModule.forceReload()}>
          Reload
        </MDSButton>
      </MDSButtonGroup>
    </MDSModalDialog>
  );
});
